import type { Method } from 'lib/axios';
import { APICallV4 } from 'reactApp/api/APICall';
import type { BillingPersonalizationResponse } from 'reactApp/api/billing/personalization/BillingPersonalizationAPICall.types';

export class BillingPersonalizationDataAPICall extends APICallV4<BillingPersonalizationResponse> {
    _method = 'billing/personalization/user/data';
    _xrayName = 'bil-pers-user-data';
    _type: Method = 'get';
    _retriesCount = 0;
}
